import React, { useState, useRef } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function SponsorRegistration() {
  const [sponsorType, setSponsorType] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [image, setImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setImage(reader.result); // base64 string
    };
    reader.readAsDataURL(file);
  };
  const handleSubmit = async () => {
    try {
      const payload = {
        sponsorType,
        firstName,
        lastName,
        companyName,
        email,
        phone,
        image,
      };

      await axios.post("https://node.aattumtpl.com/api/sponsor/register", payload);

      // SweetAlert Success
      Swal.fire({
        title: "Registration Successful!",
        text: "Sponsor has been registered successfully.",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });

      // Reset Form Fields
      setSponsorType("");
      setFirstName("");
      setLastName("");
      setCompanyName("");
      setEmail("");
      setPhone("");
      setImage(null);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

    } catch (err) {
      console.error(err);

      // SweetAlert Error
      Swal.fire({
        title: "Registration Failed",
        text: err?.response?.data?.message || "Something went wrong. Try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };


  return (
    <div className="sheet">
      {/* Banner */}
      <div className="banner">
        <img src="/Images/become-a-sponsor-banner.jpg" alt="Banner" />
      </div>

      <div className="content">
        {/* Title */}
        <h1 className="title">ATPL SPONSORSHIP FORM</h1>
        <p className="subtitle">Sponsor Registration</p>

        {/* Sponsor Type */}
        <div className="field">
          <label className="field-title">Sponsor Type</label>
          <div className="radio-row">
            <label>
              <input
                type="radio"
                value="Individual"
                checked={sponsorType === "Individual"}
                onChange={() => setSponsorType("Individual")}
              />
              Individual
            </label>

            <label>
              <input
                type="radio"
                value="Company"
                checked={sponsorType === "Company"}
                onChange={() => setSponsorType("Company")}
              />
              Company
            </label>
          </div>
        </div>

        {/* Name Section */}
        <div className="field">
          <label className="field-title">{sponsorType === "Company" ? "Company Name" : "Full Name"}</label>

          {sponsorType === "Company" ? (
            <input
              type="text"
              placeholder="Company Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
          ) : (
            <div className="grid-2">
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          )}
        </div>

        {/* Email & Phone */}
        <div className="row">
          <div className="field">
            <label className="field-title">Email</label>
            <input
              type="email"
              placeholder="example@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-title">Phone Number</label>
            <input
              type="tel"
              placeholder="+91 00000 00000"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </div>

        {/* Upload Image */}
        <div className="field">
          <label className="field-title">{sponsorType === "Company" ? "Upload Logo" : "Upload Photo"}</label>

          <div className="drop">
            <input
              type="file"
              accept="image/*"
              className="file-input"
              onChange={handleFileChange}
              ref={fileInputRef}
            />

            {image ? (
              <img
                src={image}
                alt="Preview"
                className="preview-image"
                onClick={() => fileInputRef.current.click()}
              />
            ) : (
              <div className="drop-inner" onClick={() => fileInputRef.current.click()}>
                <div className="cloud" aria-hidden />
                <strong className="text-gray-600">Browse Files</strong>
                <span className="text-gray-600">Click to upload</span>
              </div>
            )}
          </div>
        </div>

        {/* Register Button */}
        <div className="actions">
          <button type="button" className="btn" onClick={handleSubmit}>
            Register
          </button>

        </div>
      </div>

      {/* Styles */}
      <style>{`
        :root {
          --theme: #f3f3f3ff;
          --ink: #264653;
          --line: #d1e0ea;
          --accent: #0d47a1;
        }
        * { box-sizing: border-box; }

        .sheet { width: 210mm; min-height: 197mm; background: #fff; border-radius: 5px; overflow: hidden; margin: 20px auto; margin-top: 100px; }
        .content { padding: 18mm 16mm 20mm; }
        .banner { position: relative; height: 62mm; overflow: hidden; }
        .banner img { width: 100%; height: 100%; object-fit: cover; display:block; }
        .batsman-overlay { position: absolute; right: 16mm; bottom: -6mm; width: 95mm; height: 95mm;  pointer-events: none; }
        .title { margin: -30px 0 2mm; text-align: center; letter-spacing: .06em; color: #31647b; font-weight: 700; font-size: 8mm; }
        .subtitle { margin: 0 0 8mm; text-align: center; color: #64748b; font-size: 4mm; }
        .row { display: grid; grid-template-columns: 1fr 1fr; gap: 6mm; }
        .field { display: flex; flex-direction: column; gap: 1.5mm; margin-bottom: 4mm; }
        .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 2mm; }
        input, select { height: 11mm; border: 1px solid #c3d4e6; border-radius: 1.5mm; padding: 0 4mm; font-size: 3.8mm; outline: none; }

        .drop { position: relative; border: 1.5px dashed #cbd5e1; border-radius: 1.5mm; width: 100%; max-width: 173mm; height: 50mm; display: grid; place-items: center; overflow: hidden; }
        .file-input { position: absolute; inset: 0; opacity: 0; cursor: pointer; }
        .drop-inner { text-align: center; display: grid; gap: 1mm; color:grey; }
        .cloud { width: 40px; height: 40px; margin: 0 auto 8px auto; background: url("data:image/svg+xml;utf8,<svg fill='%23cc3366' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M19.35 10.04c-.68-3.59-4.08-6.04-7.76-5.26-2.41.48-4.31 2.39-4.79 4.8C4.57 10.16 3 12.03 3 14.25 3 16.73 5.02 18.75 7.5 18.75h11c2.21 0 4-1.79 4-4 0-1.93-1.37-3.57-3.15-3.96zM12 12v4m0-4l-2 2m2-2l2 2' stroke='%23888' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>") no-repeat center; background-size: contain; }
        .preview-image { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain; border-radius: 1.5mm; background: #f0f0f0; }
        .actions { display: flex; justify-content: center; margin-top: 6mm; }
        .btn { background: #007BFF; color: #fff; border: none; border-radius: 1.5mm; height: 12mm; font-size: 13px; cursor: pointer; width: 120px; }
        .btn:hover { filter: brightness(1.05); }
.radio-row {
  display: flex;
  align-items: center;
  gap: 60px;
  margin-bottom: 20px;
}

.radio-row label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color:grey;
  cursor: pointer;
}

.radio-row input[type="radio"] {
  width: 18px;
  height: 18px;
  accent-color: #007bff;
}
.field-title {
color:black;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 6px;
}
        @media screen and (max-width: 600px) {
          .sheet {
            width: 100%;
            border-radius: 0;
          }

          .row {
            grid-template-columns: 1fr;
          }
        }
        @media screen and (max-width: 600px) {
  body {
    margin-top: 80px;
  }

  .sheet {
    width: 100%;
    min-height: auto;
    border-radius: 0;
    margin: 0;
    padding: 20px;
  }

  .content {
    padding: 20px 15px;
  }

  .banner {
    height: 150px;
  }

  .batsman-overlay {
    right: 10px;
    width: 120px;
    height: auto;
    bottom: -15px;
  }

  .title {
    margin-top: 10px;
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .row {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  input, select {
    height: 42px;
    font-size: 14px;
  }

  .grid-2 {
    grid-template-columns: 1fr;
  }

  .drop {
    height: 150px;
    max-width: 100%;
  }

  .actions {
    margin-top: 20px;
  }

  .btn {
    height: 44px;
    font-size: 15px;
    width: 100%;
    max-width: 220px;
  }
}
      `}</style>
    </div>
  );
}
